module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@1x.d3c9aec8.webp";